type NavigationItemProps = {
	title: string;
	href?: string;
	description?: string;
	isInertia?: boolean;
	subItems?: NavigationItemProps[];
};

export const adminRoutes: NavigationItemProps[] = [
	{
		title: "Přehled",
		href: "/admin/v2/dashboard",
		description: "Zpět na dashboard",
		isInertia: true,
	},
	{
		title: "Sezona",
		description: "Správa sezony",
		isInertia: true,
		subItems: [
			{
				title: "Správa sezony",
				href: "/admin/v2/seasons",
				isInertia: true,
			},
			{
				title: "Správa kol",
				href: "/admin/v2/rounds",
				isInertia: true,
			},
			{
				title: "Správa skupin",
				href: "/admin/v2/groups",
				isInertia: true,
			},
		],
	},
	{
		title: "Aktuality",
		isInertia: true,
		href: "/admin/v2/articles",
	},
	{
		title: "Hráči",
		isInertia: true,
		href: "/admin/v2/players",
	},
	{
		title: "Média",
		isInertia: true,
		subItems: [
			{
				title: "Seznam galerií",
				href: "/admin/v2/galleries",
				isInertia: true,
			},
			{
				title: "Seznam videí",
				href: "/admin/v2/videos",
				isInertia: true,
			},
		],
	},
	{
		title: "Zápasy",
		isInertia: true,
		subItems: [
			{
				title: "Všechny zápasy",
				href: "/admin/v2/matches",
				isInertia: true,
			},
			{
				title: "Playoff",
				href: "/admin/v2/matches/playoff",
				isInertia: true,
			},
			{
				title: "Přidat zápas",
				href: "/admin/v2/matches/create",
				isInertia: true,
			},
		],
	},
	{
		title: "Dokumenty",
		isInertia: true,
		subItems: [
			{
				title: "Seznam dokumentů",
				href: "/admin/v2/documents",
				isInertia: true,
			},
			{
				title: "Archiv",
				href: "/admin/v2/archives",
				isInertia: true,
			},
		],
	},
];

export const publicRoutes: NavigationItemProps[] = [
	{
		title: "Aktuality",
		href: "/articles",
		isInertia: true,
	},
	{
		title: "Sezona",
		isInertia: true,
		subItems: [
			{
				title: "Rozpis zápasů",
				href: "/matches",
				isInertia: true,
			},
			{
				title: "Tabulka",
				href: "/standings",
				isInertia: true,
			},
			{
				title: "Výsledky",
				href: "/results",
				isInertia: true,
			},
			{
				title: "Playoff",
				href: "/playoff",
				isInertia: true,
			},
		],
	},
	{
		title: "Hráči",
		isInertia: true,
		href: "/players",
	},
	{
		title: "Galerie",
		isInertia: true,
		href: "/galleries",
	},
	{
		title: "Videa",
		isInertia: true,
		href: "/videos",
	},
	{
		title: "Kontakt",
		isInertia: true,
		href: "/contact",
	},
	{
		title: "Dokumenty",
		isInertia: true,
		subItems: [
			{
				title: "Veřejné dokumenty",
				href: "/documents",
				isInertia: true,
			},
			{
				title: "Archiv",
				href: "/archives",
				isInertia: true,
			},
		],
	},
	{
		title: "Pravidla",
		isInertia: true,
		href: "/rules",
	},
	{
		title: "Registrace",
		isInertia: true,
		href: "/register",
	},
	{
		title: "Administrace",
		//isInertia: true,
		href: "/admin/v2/dashboard",
	},
];
